<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn @click="onClick" v-on="on" icon small>
          <v-icon>delete</v-icon>
        </v-btn>
      </template>
      <span>案件の削除</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'DeleteButton',
  props: { insertionOrder: Object },
  methods: {
    ...mapActions('advertiser/insertionOrders', {
      search: 'SEARCH',
    }),
    async onClick() {
      const insertionOrder = this.insertionOrder
      const result = await this.$confirm(
        `${insertionOrder.name}を削除しますがよろしいですか？`,
      )
      if (result) {
        try {
          await insertionOrder.destroy()
          const message = '削除しました'
          this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
            type: snackbarType.SUCCESS,
            message,
          })
          this.search()
        } catch (e) {
          console.error(e)
          const message = '削除に失敗しました'
          this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
            type: snackbarType.ERROR,
            message,
          })
        }
      }
    },
  },
}
</script>
